
import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import LoginForm from '@/components/LoginForm';
import ResetPasswordForm from '@/components/ResetPasswordForm';
import { useEffect } from 'react';

const Auth = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  
  const isResetMode = searchParams.get('reset') === 'true' || 
                     (searchParams.get('type') === 'recovery' && searchParams.has('token'));
  const returnUrl = searchParams.get('returnUrl');
  
  // Redirect authenticated users to their intended destination
  useEffect(() => {
    if (user) {
      const destination = returnUrl ? decodeURIComponent(returnUrl) : '/assessments';
      navigate(destination, { replace: true });
    }
  }, [user, returnUrl, navigate]);

  if (isResetMode) {
    return <ResetPasswordForm />;
  }

  return (
    <div className="min-h-[calc(100vh-4rem)] bg-brand-gradient flex items-center justify-center p-4">
      <LoginForm />
    </div>
  );
};

export default Auth;
